<template>
  <v-card>
    <v-card-text>
      <small><b>{{ $t('variation.historySection') }}</b></small>
      <v-timeline
        align-top
        dense
      >
        <v-timeline-item
          v-for="(entry, i) in history"
          :key="entry.id || `${entry.type}-${entry.createdAt}-${i}`"
          :color="entry.color"
          small
        >
          <v-row>
            <v-col cols="3">
              <strong>{{entry.createdAt | formatDate}}</strong>
            </v-col>
            <v-col>
              <div v-if="getEntryDescription(entry)" class="text-caption history-entry-text">
                {{getEntryDescription(entry)}}
              </div>
              <div v-if="entry.comment" class="text-caption history-entry-text">
                {{entry.comment}}
              </div>
              <div class="text-caption">
                {{entry.type}} by {{ entry.user}}
              </div>
              <div v-if="canCommentEntry(entry)" class="mt-1 d-flex align-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-btn
                        icon
                        small
                        color="primary"
                        :disabled="!canUserComment"
                        :aria-label="commentActionLabel(entry)"
                        @click="$emit('SAVE_HISTORY_COMMENT', entry)"
                      >
                        <v-icon>{{ commentActionIcon(entry) }}</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>{{ commentActionLabel(entry) }}</span>
                </v-tooltip>
                <div v-if="entry.userComment" class="text-caption history-entry-text ml-2">
                  <b>{{ $t('variation.userComment') }}:</b> {{entry.userComment}}
                </div>
              </div>
            </v-col>
            <v-col cols="2" v-if="showDelete && entry.type === 'comment' && i === history.length - 1">
              <SubmitButton
                icon="mdi-delete"
                :disabled="!canUserComment"
                @click="$emit('DELETE_COMMENT', entry)"
              />
            </v-col>
          </v-row>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'VariationTimeline',
  props: {
    history: {
      type: Array,
      default: () => []
    },
    showDelete: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      canUserComment: state => state.userPermissionsToContract.canUserComment
    })
  },
  methods: {
    getEntryDescription (entry) {
      return entry.changeDescription || entry.description || ''
    },
    canCommentEntry (entry) {
      return entry.type === 'update'
    },
    commentActionLabel (entry) {
      return entry.userComment && entry.userComment.trim()
        ? this.$t('variation.editComment')
        : this.$t('variation.addComment')
    },
    commentActionIcon (entry) {
      return entry.userComment && entry.userComment.trim()
        ? 'mdi-message-text-outline'
        : 'mdi-message-plus-outline'
    }
  }
}
</script>

<style scoped>
.history-entry-text {
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
